<canvas #canvasDocument class="canvas"></canvas>
<footer class="footer">
  <div class="footer__raycast"><b>x: </b>{{ raycastInfoX }}</div>
  <div class="footer__raycast"><b>y: </b>{{ raycastInfoY }}</div>
  <div class="footer__raycast"><b>z: </b>{{ raycastInfoZ }}</div>
  <div class="footer__raycast"><b>id: </b>{{ raycastInfoId }}</div>
  <div class="footer__raycast"><b>type: </b>{{ raycastInfoType }}</div>
  <div class="footer__button-group"></div>
</footer>
